const lang = {
    srb: {
        o_name: "O NAMA",
        reference: "REFERENCE",
        usluge: "USLUGE",
        galerija: "GALERIJA",
        misija: 'MISIJA',
        vizija: 'VIZIJA',
        elementi: 'ELEMENTI',
        prikazi_vise: 'PRIKAŽI VIŠE',
        igraonice: 'IGRAONICE',
        bam_igraonice: 'BAM_IGRAONICE',
        kontakt: 'KONTAKT',
        telefon_1: '062-44-0313',
        telefon_2: '064-81-07921',
        mejl: 'bamigraonice@gmail.com',
        section: {
            about: {
                t1: 'MI SMO TIM BAM IGRAONICA ',
                t2: 'Posvećeni projektovanju, izradi, opremanju I montiranju dečijih unutrašnjih I spoljašnjih igraonica, kao I dečijih kutaka.',
                t3: `Ideja o Bam igraonicama nastala je 2008.godine kada su se dvojica kolega I prijatelja, ` +
                    `složili oko istog cilja – stvoriti više prostora za decu, u 21.veku, kada je prirodnog ` +
                    `prostora sve manje. Marljivim radom I ukazanim poverenjem uspeli smo da okupimo tim ` +
                    `profesionalaca koji dele naše osnovne vrednosti I ljubav prema poslu.Tokom 11.godina rasli smo, ` +
                    `napredovali I postali jedna od vodećih firmi za kompletnu profesionalnu izradu I opremu dečijih ` +
                    `unutrašnjih I spoljašnjih igraonica, kao I kutaka za decu. Ponosni smo na sopstvenu proizvodnju I ` +
                    `činjenicu da su materijali od kojih izrađujemo  visokog kvaliteta I da su sertifikovani po ` +
                    `Evropskoj normi EN 1176 što obezbeđuje sigurnost dece I razvoj vašeg biznisa! Što je I naš uspeh! ` +
                    `Sedište firme je u Beogradu ali već godinama intenzivno radimo I u ostalim gradovima Srbije, ` +
                    `u Novom Sadu, Šapcu, Kragujevcu, Staroj Pazovi, Kraljevu, Somboru, Zrenjaninu Nišu,...` +
                    `Naše poslovanje prelazi I granice naše zemlje te intenzivno radimo i u zemljama regiona – Crnoj Gori, ` +
                    `Makedoniji, Bosni i Hercegovini I Hrvatskoj. ` +
                    `\nPored toga što oprema I izrađuje naš tim vodi,prati I proverava celokupan proces izrađivanja ` +
                    `prostora za decu I sa vama je od početka do kraja tog procesa!`,
                t4: 'Kontaktirajte nas!',
                t5: 'Radujemo se stvaranju nove igraonice!'
            },
            element: {
                t1: '"Spoj bezbednog I zabavnog, brzog I detaljnog, kvalitetnog I povoljnog, \n omogućava vam BAM!"',
                t2: 'Elementi',
                t3: 'OD ČEGA PRAVIMO?',
                t4: 'Pogledajte nase sastavne elemente koje mozete kupiti i pojedinacno. Odaberite svoju igraonicu!',
                t5: 'Pogledajte nase sastavne elemente koje mozete kupiti i pojedinacno. Odaberite svoju igraonicu!',
                tobogan: {
                    title: 'TOBOGAN',
                    text: 'Pogledajte nase sastavne elemente koje mozete kupiti i pojedinacno. Odaberite svoju igraonicu!',
                }
            },
            whyUs: {
                title_start: "ZAŠTO ODABRATI",
                title_end: " NAS?",
                kreativnost: {
                    title: 'KREATIVNOST',
                    body: 'u osmišljavanju vaše igraonice'
                },
                preciznost: {
                    title: 'PRECIZNOST',
                    body: 'proračuna i izrade'
                },
                brzina: {
                    title: 'BRZINA',
                    body: 'sklapanja i montiranja'
                },
                sigurnost: {
                    title: 'SIGURNOST',
                    body: 'i bezbednost dece'
                },
                garancija: {
                    title: 'GARANCIJA',
                    body: 'dugovečnosti vaše igraonice'
                },
                efikasnost: {
                    title: 'EFIKASNOST',
                    body: 'i odgovornost naših radnika'
                }
            },
            contact: {
                naslov: 'Ostanimo u kontaktu',
                posaljite_nam_poruku: 'Pošaljite nam poruku',
                ime_i_prezime: 'Ime i prezime',
                poruka: 'Poruka',
                posalji: 'POŠALJI',
                kontakt: 'Kontakt',
                pozovite_nas: 'Pozovite nas',
                posaljite_mejl: 'Pošaljite mejl'
            },
            footer: {
                o_nama: 'O_NAMA',
                igraonice: 'IGRAONICE',
                bam_igraonice: 'BAM IGRAONICE',
                kontakt: 'KONTAKT',
                kako_radimo: 'KAKO RADIMO?',
                ko_su_nam_kupci: 'KO SU NAM KUPCI?',
                zasto_bas_mi: 'ZASTO BAS MI?',
                elementi: 'ELEMENTI',
                usluge: 'USLUGE',
                galerija: 'GALERIJA',
                nasa_misija: 'Naša misija je profesionalna izrada dečijih igraonica za sve vrste lokala, zatvorenih i otvorenih prostora.',
                nasa_lokacija_title: 'Naša lokacija',
                nasa_lokacija_adresa: 'Mijatovih njiva',
                nasa_lokacija_grad: '11000 Beograd-Sremčica',
                telefon: 'Telefon',
                telefon_1: '062-44-0313',
                telefon_2: '064-81-07921',
                radno_vreme: 'Radno vreme',
                radno_vreme_radni_dani: 'Ponedeljak-Petak od 08-22',
                radno_breme_vikend: 'Subota-Nedelja od 08-22',
                copyright: 'Copyright @ 2018 BAM igraonice. Sva prava zadržana',
            },
            reference: {
                reference: "Reference",
                za_koga_smo_radili: "Za koga smo radili?"
            },
            gallery: {
                title: 'Galerija naših igraonica',
                sub_title: 'Pogledajte neke od naših značajnih projekata',
                mostici: 'MOSTIĆI',
                penjalice: 'PENJALICE',
                skakalice: 'SKAKALICE',
                tobogani: 'TOBOGANI',
                lavirinti: 'LAVIRINTI',
            },
            service: {
                nacrti_i_projektovanje: {
                    nad_naslov: 'Naše usluge',
                    naslov: 'NACRTI I PROJEKTOVANJE ',
                    opis: 'Pre nego sto udjemo u proces izrade igraonice ono sto prethodi a nama je od izuzetnog znacaja ' +
                        'i jeste prvi susret. Tada treba ustanoviti prostor, izmeriti ga i razmotriti najbolja izvedbena resenja. ' +
                        'Pravi se nacrt, po vasoj zamisli. Ukoliko jos uvek niste sigurni kako zelite da tacno izgleda vasa igraonica, ' +
                        'nas tim je tu da predlozi potencijalna resenja vaseg prostora.  Nakon ustanovljenog dizajna i ' +
                        'gotovog nacrta sa svim merama, pristupamo PROJEKTOVANJU. \n' +
                        'Izrada projekta se radi u 2D i 3D modelima (programi:AutoCAD 2012, 3D Max, Inventor) i ' +
                        'dostavlja se u elektronskom formatu sa specifikacijom materijala, cenom materijala i ukupnom' +
                        ' cenom koja uključuje i izradu projekta. \n' +
                        ' '
                },
                izrada_i_kvalitet: {
                    nad_naslov: 'Naše usluge',
                    naslov: 'IZRADA  I KVALITET ',
                    opis: 'Bezbednost dece i dugotrajna decija igraonica je cilj - radi uspesnosti vaseg biznisa, radi naseg ugleda i daljeg poslovanja! \n' +
                        'U nasim radionicama vrsi se montaza konstruktivnih elmenata, izgradnja mreza nosecih konstukcija (kaveza), tapaciranje (Svaki konstruktivni deo je taciran sto ga cini potpuno bezbednim za upotrebu),...  \n' +
                        'Svaki element koji se izradjuje u nasim radionicama je strogo kontrolisan a materijali sa kojima radimo provereni i sertifikovani. Proizvode se po strogoj evropskoj normi EN 1176. Postovanje te norme garantuje bezbednost decije unutrasnje i spoljanje igraonice i vaseg decijeg kutka. Koristimo netoksicni i nezapaljivi PVC kao i najfinije obložene konopce kako ne bi doslo do pucanja i cepanja. '
                },
                ugradnja_i_sigurnosne_provere: {
                    nad_naslov: 'Naše usluge',
                    naslov: ' UGRADNJA I SIGURNOSNE PROVERE ',
                    opis: 'Brzo, pouzdano, provereno \n' +
                        '11.godina iskustva pomoglo nam je da zavrsni korak izrade vase igraonice obavljamo brzo i efikasno. Montiranje igraonice i ugradnja sastavnih elemenata obavlja se u vec pripremljenom prostoru nakon čega slede provere stabilnosti i bezbednosti igraonice. Naš tim izvršava I nadgleda radove od početka do kraja. '
                }
            },
            notification: {
                success_title: 'Vasa poruka je uspesno poslata!',
                success_description: 'Uskoro cemo vas kontaktirati. Hvala',
                error_title: 'Trenutno nije moguce slanje poruke putem kontakt forme!',
                error_description: 'Molimo vas da nas kontaktirate telefonom na: \n062-44-0313 ili putem email-a: bamigraonice@gmail.com'
            }

        }
    }
};

export default lang;